const keyMirror = require("keymirror");

export const KioskConstant = keyMirror({
  CHECK_PRINTER_MODE: undefined,
  KIOSK_TRANSLATE: undefined,
});
